export default __webpack_public_path__ + "static/media/8.899df847.png";